import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Polling interval of 10 seconds.
 */
const POLLING_INTERVAL = 10e3

/**
 * Initiates a timer with the specified {@link POLLING_INTERVAL} to periodically
 * request process updates.
 */
// TODO: should be removed once we support subscriptions.
export const requestOnTimer = store.effects.create(
  (
    feature: Plugin['feature'],
    plugin: Plugin,
    localStorage: Plugin['localStorage'],
  ) =>
    localStorage.selectors.isStarted.asObservable.pipe(
      rxjs.switchMap(isStarted =>
        // Start the timer only if polling is enabled.
        isStarted
          ? rxjs
              .interval(POLLING_INTERVAL) // timer that emits every POLLING_INTERVAL
              .pipe(
                rxjs.map(() =>
                  plugin.collection.plugins.currentListPlugin.feature.actions.load
                    .from('requestOnTimer (effect)')
                    .create(),
                ),
              )
          : // Cancel the timer when polling is stopped.
            rxjs.EMPTY,
      ),
    ),
)
